// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3X3bv","col":"styles_col__3AHLS"};